import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { Form, Input, Button, Col, Row, Modal, Table, Tag, Select, Radio } from 'antd';
import { LeftOutlined, PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';
import UserModal from '../userModal';
import { mapFullNameAbbr, mapCountry } from '../../../Common'
import { checkAccess } from '../../../Auth'
import { UR_Owner } from '../../../State'
import { message } from 'antd';
import { useDispatch } from 'react-redux';
import { track } from 'statsig';
import { STATSIG, paymentPayProps } from 'statsig/events';  

import './index.css'
import {
    Elements,
    CardElement,
    PaymentElement,
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
    useStripe,
    useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { getStripePublicKey } from '../../../Billing/Prices';


function Information(props, ref) {
    const { getInfo, payID, loanOfficers, billingFrequency, stripeCustomerID, userNum, promoCode, appliedPromoCode, chosenPlan, paymentMethodsExpanded, setPaymentMethodsExpanded } = props
  
    const [form] = Form.useForm();
    const elements = useElements();
    const stripe = useStripe();

    const validateMessages = {
        required: '${label} is required!',
        types: {
            email: '${label} is not a valid email!',
        }
    }
    useImperativeHandle(ref, () => ({
        click() {

            document.getElementById('submit').click()
        },

    }))

    return (

        <div 
            style={{
                backgroundColor: "#f6f6f6",
                borderRadius: 12,
                padding: "16px 20px",
                width: "100%",
                fontFamily: "Inter, sans-serif",
            }}
        >
            <div
                style={{
                    margin: 0,
                    marginBottom: 12,
                    color: "#000",
                    fontFamily: "Inter",
                    fontSize: 16,
                    fontStyle: "normal",
                    fontWeight: 600,
                    letterSpacing: 0.5,
                }}
            >
                Select your payment method
            </div>
            
            {/* Secure Checkout Header */}
            <div
                style={{
                    backgroundColor: "#f5f5f7",
                    border: "1px solid #d9d9d9",
                    borderRadius: "10px 10px 0 0",
                    padding: "12px 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: -1,
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div
                        style={{
                            width: 24,
                            height: 24,
                            position: "relative",
                            display: "inline-block",
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M3 4.25V12.1877C3 15.5966 4.92602 18.713 7.97508 20.2375L12 22.25L16.0249 20.2375C19.074 18.713 21 15.5966 21 12.1877V4.25L20.2159 4.33712C17.461 4.64322 14.6901 3.92152 12.4346 2.31043L12 2L11.5654 2.31043C9.30988 3.92152 6.53898 4.64322 3.78411 4.33712L3 4.25Z"
                                fill="#474849"
                            />
                            <path
                                d="M10.875 14.375L8.625 12.125M3 4.25V12.1877C3 15.5966 4.92602 18.713 7.97508 20.2375L12 22.25L16.0249 20.2375C19.074 18.713 21 15.5966 21 12.1877V4.25L20.2159 4.33712C17.461 4.64322 14.6901 3.92152 12.4346 2.31043L12 2L11.5654 2.31043C9.30988 3.92152 6.53898 4.64322 3.78411 4.33712L3 4.25Z"
                                stroke="#474849"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <rect
                                x="6"
                                y="11.5354"
                                width="2"
                                height="7"
                                transform="rotate(-45 6 11.5354)"
                                fill="white"
                            />
                            <rect
                                x="16.6055"
                                y="8"
                                width="2"
                                height="10"
                                transform="rotate(45 16.6055 8)"
                                fill="white"
                            />
                        </svg>
                    </div>
                    <span
                        style={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: "#222222",
                        }}
                    >
                        Secure Checkout
                    </span>
                </div>
            </div>

            {/* Credit Card Row */}
            <div
                style={{
                    backgroundColor: "#f5f5f7",
                    border: "1px solid #d9d9d9",
                    borderTop: "none",
                    padding: "12px 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: -1,
                    borderTop: "1px solid #d9d9d9", 
                    backgroundColor: "#ffffff",
                    borderRadius: !paymentMethodsExpanded ? "0 0 12px 12px": '0',
                    paddingTop: "12px",
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <span
                        style={{
                            fontSize: 16,
                            fontWeight: 500,
                            color: "#222222",
                        }}
                    >
                        Credit Card
                    </span>
                </div>
                
                {/* Payment Method Icons */}
                <div
                    className="flex items-center gap-3"
                    style={{ display: "flex", alignItems: "center", gap: 12 }}
                >
                    <img
                        src="/images/American_Express_logo_(2018).svg.svg"
                        alt="American Express"
                        style={{ width: 14, height: 14 }}
                    />
                    <img
                        src="/images/Discover-logo.svg"
                        alt="Discover"
                        style={{ width: 63, height: 14 }}
                    />
                    <img
                        src="/images/Mastercard-logo.svg.svg"
                        alt="Mastercard"
                        style={{ width: 18, height: 14 }}
                    />
                    <img
                        src="/images/Visa_2021.svg.svg"
                        alt="Visa"
                        style={{ width: 43, height: 14 }}
                    />
                    
                    {/* Expand/Collapse Button */}
                    {/* <button
                        type="button"
                        onClick={() => setPaymentMethodsExpanded(!paymentMethodsExpanded)}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '4px'
                        }}
                    >
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                                transform: paymentMethodsExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.2s'
                            }}
                        >
                            <path
                                d="M7 10l5 5 5-5"
                                stroke="#666"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button> */}
                </div>
            </div>

            {/* Payment Methods Container */}
            <div
                className='price-select-box'
                style={{
                    backgroundColor: "#ffffff",
                    border: "1px solid #d9d9d9",
                    borderTop: "none",
                    borderRadius: "0 0 10px 10px",
                    marginBottom: -1,
                    display: paymentMethodsExpanded ? 'block' : 'none',
                    transition: 'all 0.3s ease'
                }}
            >
                <div style={{ padding: 16 }}>
                    <Form
                        onFinish={onFinish}
                        form={form}
                        layout='vertical'
                        validateMessages={validateMessages}
                    >
                <div style={{ display: "flex", gap: 20, marginBottom: 20 }}>
                    <div style={{ flex: 1 }}>
                        <Form.Item
                            name="firstName"
                            label="First Name"
                            style={{ marginBottom: 6 }}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your first name',
                                },
                            ]}
                        >
                            <Input 
                                placeholder="First name on card" 
                                style={{
                                    background: "#FCFCFC",
                                    border: "0.875px solid #ECECEC",
                                    borderRadius: 7,
                                    padding: "13px 12px",
                                    fontSize: 16,
                                    color: "#222",
                                    height: 46,
                                }}
                            />
                        </Form.Item>
                    </div>
                    <div style={{ flex: 1 }}>
                        <Form.Item
                            name="lastName"
                            label="Last Name"
                            style={{ marginBottom: 6 }}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your last name',
                                },
                            ]}
                        >
                            <Input 
                                placeholder="Last name on card" 
                                style={{
                                    background: "#FCFCFC",
                                    border: "0.875px solid #ECECEC",
                                    borderRadius: 7,
                                    padding: "13px 12px",
                                    fontSize: 16,
                                    color: "#222",
                                    height: 46,
                                }}
                            />
                        </Form.Item>
                    </div>
                </div>
                <div style={{ marginBottom: 20 }}>
                    <Form.Item
                        name="Card "
                        label="Credit or debit card number"
                        style={{ marginBottom: 6 }}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        rules={[
                            {
                                required: true,
                                message: 'Please input your card number',
                            },
                        ]}
                    >
                        <CardNumberElement 
                            options={{
                                style: {
                                    base: {
                                        fontSize: "16px",
                                        color: "#222",
                                        border: "0.875px solid #ECECEC",
                                        backgroundColor: "#FCFCFC",
                                        "::placeholder": {
                                            color: "#808080",
                                            fontWeight: 400,
                                            // fontFamily: "Inter",
                                        },
                                    },
                                },
                            }}
                        />
                    </Form.Item>
                </div>
                <div style={{ display: "flex", gap: 20, marginBottom: 20 }}>
                    <div style={{ flex: 1 }}>
                        <Form.Item
                            name="Expiration Date "
                            label="Expiration date"
                            style={{ marginBottom: 6 }}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Expiration Date'
                                },
                            ]}
                        >
                            <CardExpiryElement 
                                options={{
                                    style: {
                                        base: {
                                            fontSize: "16px",
                                            color: "#222",
                                            backgroundColor: "#FCFCFC",
                                            "::placeholder": {
                                                color: "#808080",
                                                fontWeight: 400,
                                                // fontFamily: "Inter",
                                            },
                                        },
                                    },
                                }}
                            />
                        </Form.Item>
                    </div>
                    <div style={{ flex: 1 }}>
                        <Form.Item
                            name="cvc "
                            label="CVC"
                            style={{ marginBottom: 6 }}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your CVC'
                                },
                            ]}
                        >
                            <CardCvcElement 
                                options={{
                                    style: {
                                        base: {
                                            fontSize: "16px",
                                            color: "#222",
                                            backgroundColor: "#FCFCFC",
                                            "::placeholder": {
                                                color: "#808080",
                                                fontWeight: 400,
                                                // fontFamily: "Inter",
                                            },
                                        },
                                    },
                                }}
                            />
                        </Form.Item>
                    </div>
                </div>
                <div style={{ display: "flex", gap: 20 }}>
                    <div style={{ flex: 1 }} className='price-select-item'>
                        <Form.Item
                            className='labelItem'
                            name="Country or region"
                            label="Country"
                            style={{ marginBottom: 6 }}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                        >
                            <Select 
                                placeholder='United States' 
                                style={{
                                    background: "#FCFCFC",
                                    fontSize: 16,
                                    color: "#222",
                                    height: 46,
                                }}
                                options={
                                    Object.entries(mapCountry)
                                    .map(([value, label]) => ({
                                        label: label.charAt(0).toUpperCase() + label.slice(1),
                                        value
                                    }))
                                    .sort((a, b) => a.label.localeCompare(b.label))
                                }
                            />
                        </Form.Item>
                    </div>
                    <div style={{ flex: 1 }}>
                        <Form.Item
                            label={<div>ZIP / Postal code</div>}
                            name="num"
                            style={{ marginBottom: 6 }}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your ZIP / Postal code',
                                },
                            ]}
                        >
                            <Input 
                                placeholder="12345" 
                                style={{
                                    background: "#FCFCFC",
                                    border: "0.875px solid #ECECEC",
                                    borderRadius: 7,
                                    padding: "13px 12px",
                                    fontSize: 16,
                                    color: "#222",
                                    height: 46,
                                }}
                            />
                        </Form.Item>
                    </div>
                </div>
                {/* style={{ opacity: 0 }} */}
                <Button type="primary" htmlType="submit" id='submit' style={{ opacity: 0 }} >
                    Submit
                </Button>

                    </Form>
                </div>
            </div>
        </div>

    )

    async function onFinish(val) {
        getInfo({
            back: false,
            loading: true,
            to: false
        })
        try {

            if (!stripe || !elements) {
                // Stripe.js has not yet loaded.
                return;
            }
            const cardElement = elements.getElement(CardNumberElement);
            console.log(cardElement);
            if (!cardElement) {
                // Handle the case where the card element isn't found
                alert('Please enter your card information')
                return;
            }
            const result = await stripe.createPaymentMethod({
                type: "card",
                card: cardElement,
            });
            // console.log(result);
            if (result.error) {
                // Handle errors
                console.error(result.error.message);
                getInfo({
                    back: false,
                    loading: false,
                    to: false
                })
                alert(result.error.message)
                const isAnnual = String(billingFrequency || '').toLowerCase().startsWith('annual')
                const pay = paymentPayProps(chosenPlan, isAnnual, 'fail', 'management')
                if (pay) track(STATSIG.PAYMENT.PAY, pay.value, pay.metadata)

                return
            }
            const { setupIntent } = await stripe
                .confirmCardSetup(payID, {
                    payment_method: result.paymentMethod.id,
                })
            let token = sessionStorage.getItem("ZeitroA")
            getInfo({
                back: false,
                loading: true,
                to: false
            })
            // console.log(
            //     'selectedLoanOfficerIDs', chosenPlan === 'business' ? (userNum > 1 ? loanOfficers : loanOfficers.map(item => item.ID)) : loanOfficers.map(item => item.ID),
            // )
            let officerIds = []
            if( loanOfficers[0] && loanOfficers[0].ID) {
                officerIds = loanOfficers.map(item => item.ID)
            } else {
                officerIds = loanOfficers
            }
            console.log('officerIds---------', officerIds, {
                paymentMethodId: setupIntent.payment_method,
                billingFrequency: billingFrequency.toLowerCase(),
                selectedLoanOfficerIDs: officerIds, //chosenPlan === 'business' ? loanOfficers : loanOfficers.map(item => item.ID),
                stripeCustomerID: stripeCustomerID,
                promoCode: appliedPromoCode || promoCode,
                planType: chosenPlan
            })
            // setTimeout(() => {
            //     console.log('getInfo---------')
            //     getInfo({
            //         back: true,
            //         loading: false,
            //         to: false
            //     })

            // }, 3000)
            // return;
            try {
                const response = await fetch('/los/subscribetopaidplan', {
                    method: 'post',
                    headers: {
                        Authorization: "Bearer " + token,
                        Cache: "no-cache"
                    },
                    body: JSON.stringify({
                        paymentMethodId: setupIntent.payment_method,
                        billingFrequency: billingFrequency.toLowerCase(),
                        selectedLoanOfficerIDs: officerIds, //chosenPlan === 'business' ? loanOfficers : loanOfficers.map(item => item.ID),
                        stripeCustomerID: stripeCustomerID,
                        promoCode: appliedPromoCode || promoCode,
                        planType: chosenPlan
                    })
                })

                if (response.status !== 200) {
                    // console.log('response-----', response)
                    
                    // 尝试获取 response 中的错误信息
                    let errorMessage = 'Something went wrong, please try later'
                    try {
                        const errorData = await response.text() // 或者使用 response.json() 如果返回的是 JSON
                        console.log('Error response data:', errorData)
                        
                        // 如果返回的是 JSON 格式，尝试解析
                        if (errorData) {
                            try {
                                const parsedError = JSON.parse(errorData)
                                if (parsedError.message) {
                                    errorMessage = parsedError.message
                                } else if (parsedError.error) {
                                    errorMessage = parsedError.error
                                }
                            } catch (parseError) {
                                // 如果不是 JSON 格式，直接使用文本内容
                                if (errorData.trim()) {
                                    errorMessage = errorData
                                }
                            }
                        }
                    } catch (readError) {
                        console.log('Could not read error response:', readError)
                    }
                    
                    // 显示具体的错误信息
                    alert(`Error: ${errorMessage}`)
                    
                    getInfo({
                        back: false,
                        loading: false,
                        to: true
                    })
                    const isAnnual = String(billingFrequency || '').toLowerCase().startsWith('annual')
                    const pay = paymentPayProps(chosenPlan, isAnnual, 'fail', 'management')
                    if (pay) track(STATSIG.PAYMENT.PAY, pay.value, pay.metadata)
                    return
                } else {
                  
                    getInfo({
                        back: true,
                        loading: false,
                        to: false
                    })
                    const isAnnual = String(billingFrequency || '').toLowerCase().startsWith('annual')
                    const pay = paymentPayProps(chosenPlan, isAnnual, 'success', 'management')
                    if (pay) track(STATSIG.PAYMENT.PAY, pay.value, pay.metadata)
                }
            } catch (error) {
                alert('Something went wrong, please try later')
                getInfo({
                    back: false,
                    loading: false,
                    to: true

                })
                const isAnnual = String(billingFrequency || '').toLowerCase().startsWith('annual')
                const pay = paymentPayProps(chosenPlan, isAnnual, 'fail', 'management')
                if (pay) track(STATSIG.PAYMENT.PAY, pay.value, pay.metadata)
            }

        } catch (error) {

            getInfo({
                back: false,
                loading: false,
                to: false
            })
            const isAnnual = String(billingFrequency || '').toLowerCase().startsWith('annual')
            const pay = paymentPayProps(chosenPlan, isAnnual, 'fail', 'management')
            if (pay) track(STATSIG.PAYMENT.PAY, pay.value, pay.metadata)
        }

    }
}
const NewInformation = forwardRef(Information)
export default function Upgrade(props) {
    const { back, loanOfficers, stripeCustomer, userNumber, chosenPlan, invite, currentPlan, recurringInterval } = props
    const dispatch = useDispatch();
    const [isChecked, setIsChecked] = useState(true)
    const [userNum, setUserNum] = useState(1)
    // const [isPay, setIsPay] = useState(false) // No longer needed since payment form is always visible
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [ModalOpen, setModalOpen] = useState(false)
    // const [continueLoading, setContinueLoading] = useState(false) // No longer needed
    const [payLoading, setPayLoading] = useState(false)
    const [payID, setPayId] = useState('')
    const [stripeCustomerID, setStripeCustomerID] = useState('')
    const [CurrentLoanOfficers, setCurrentLoanOfficers] = useState([])
    const [promoCode, setPromoCode] = useState('')
    const [promoCodeApplied, setPromoCodeApplied] = useState(false)
    const [promoCodeError, setPromoCodeError] = useState(false)
    const [appliedPromoCode, setAppliedPromoCode] = useState('')
    const [promoCodeExpanded, setPromoCodeExpanded] = useState(false)
    const [paymentMethodsExpanded, setPaymentMethodsExpanded] = useState(true)

    const businessPlanUserLimit = 30

    // Add useEffect to handle billing frequency changes

    useEffect(() => {
        if (promoCodeApplied && promoCode) {
            const code = promoCode.toUpperCase();
            setAppliedPromoCode(isChecked ? `${code}YEAR` : code);
        }
    }, [isChecked, promoCode, promoCodeApplied]);

    // 处理 individual 年付用户的升级限制
    useEffect(() => {
        // 如果是 individual 年付用户，强制选择年付
        if (currentPlan === 'originator' && ['annually', 'yearly'].includes(recurringInterval)) {
            setIsChecked(true);
        }
    }, [currentPlan, recurringInterval]);

    const stripePromise = loadStripe(
        getStripePublicKey()
    );
    const info = useRef(null)

    useEffect(() => {

        if (userNumber === undefined) return
        setUserNum(userNumber)

    }, [
        userNumber
    ])
    useEffect(() => {

        if (loanOfficers === undefined) return
        setCurrentLoanOfficers(loanOfficers)


    }, [
        loanOfficers
    ])

    // Initialize Stripe setup intent when component mounts
    useEffect(() => {
        const initializeStripeSetup = async () => {
            if (!stripeCustomer?.customer?.id) return;
            
            let token = sessionStorage.getItem("ZeitroA")
            try {
                const response = await fetch('/los/stripe/getorcreatesetupintent', {
                    method: 'post',
                    headers: {
                        Authorization: "Bearer " + token,
                        Cache: "no-cache"
                    },
                    body: JSON.stringify({
                        customerId: stripeCustomer.customer.id
                    })
                })

                const { client_secret, customer } = await response.json()
                setPayId(client_secret)
                setStripeCustomerID(customer.id)
            } catch (error) {
                console.error('Failed to initialize Stripe setup:', error)
            }
        }

        initializeStripeSetup()
    }, [stripeCustomer])
    // const clickContinue = async () => {
    //     // This function is no longer needed since Stripe setup is handled in useEffect
    // }
    const options = {
        // passing the client secret obtained from the server
        clientSecret: payID,
    };
    const handleApplyPromoCode = () => {
        if (!promoCode.trim()) return;
        
        // Check for valid promo codes
        const validPromoCodes = ['MAXCLASS90', 'MAXCLASS60', 'ZEITRO30', 'WELCOME30', 'SPECIAL30', 'ORIGINATOR60', 'WELCOME60', 'SPECIAL60', 'PREMIUM90', 'SPECIAL90', 'WELCOME90','FRIENDS90', 'FRIENDS180'];
        const code = promoCode.toUpperCase();
        if (validPromoCodes.includes(code)) {
            setPromoCodeApplied(true);
            setPromoCodeError(false);
            // If annually plan, append YEAR to the promo code
            setAppliedPromoCode(isChecked ? `${code}YEAR` : code);
        } else {
            setPromoCodeError(true);
            setPromoCodeApplied(false);
        }
    }

    const handleRemovePromoCode = () => {
        setPromoCodeApplied(false);
        setPromoCode('');
        setAppliedPromoCode('');
    }

    return (


        <div style={{padding: '0 10px'}} className='upgrade'>
            <div className='' style={{ marginBottom: 20 }}>
                <span 
                    className="back-title"
                    onClick={() => {
                        back()
                    }}
                >
                    <span style={{ marginRight: 8, padding: "7px 4px" }}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="13"
                            viewBox="0 0 8 13"
                            fill="none"
                        >
                            <path
                            d="M6.29871 12.1342L7.35938 11.0736L1.70252 5.4167L0.64186 6.47736L6.29871 12.1342Z"
                            fill="#325CEB"
                            />
                            <path
                            d="M7.35926 1.88031L6.2986 0.81965L0.64186 6.47736L1.70241 7.53716L7.35926 1.88031Z"
                            fill="#325CEB"
                            />
                        </svg>
                    </span>
                    <span>Select your plan</span>
                </span>
            </div>
            {/* <div className="back-header-title" style={{marginBottom: 20}}>Payment</div> */}
            <Row gutter={16} className='upgradeRow'>
                <Col lg={15} span={24}>
                    <div className='plansAndPricing-leftCard-new payment-form'>
                        {/* {isPay ? <Elements
                            stripe={stripePromise}
                            options={options}
                        ><NewInformation
                            chosenPlan={chosenPlan}
                            userNum={userNum} 
                            stripeCustomerID={stripeCustomerID} 
                            promoCode={promoCodeApplied ? promoCode : undefined}
                            appliedPromoCode={appliedPromoCode}
                            ref={info} 
                            payID={payID} 
                            loanOfficers={CurrentLoanOfficers} 
                            billingFrequency={isChecked ? 'Annually' : 'Monthly'} 
                            getInfo={(e) => {
                                if (e.to) {
                                    back()
                                    return
                                }

                                if (e.back) {
                                    setModalOpen(true)

                                } else {
                                    setPayLoading(e.loading)
                                }
                            }} ></NewInformation></Elements> : */}
                            <div className=''>

                                {/* {chosenPlan === 'business' && <div className='lansAndPricing-leftCard-plan' style={{ display: 'flex', justifyContent: "space-between" }}><div>Selected <span style={{ color: "#325CEB" }}>{CurrentLoanOfficers.length}</span> Users to Upgrade</div>       {


                                    userNum > 1 ? <div style={{ color: '#325CEB', cursor: "pointer", textDecorationLine: 'underline' }} onClick={() => {

                                        setIsModalOpen(true)

                                    }}>Manage selected users</div> : <></>
                                }</div>} */}

                                <div className='payment-page-title-confirm-title'>Confirm your billing cycle</div>
                                <div className='payment-page-title-confirm'>
                                    <span className="payment-page-title-confirm-save">
                                        Save ${chosenPlan === 'business' ? 60 : 16}/year &nbsp;
                                    </span>
                                    <span className="payment-page-title-confirm-when">
                                        when you select annual billing cycle
                                    </span> 
                                </div>
                                <div 
                                    style={{
                                        border: isChecked ? "2px solid #325CEB" : "1px solid #D9D9D9",
                                        borderRadius: "10px",
                                        padding: "12px",
                                        marginBottom: "12px",
                                        cursor: "pointer",
                                        background: "#fff",
                                    }}
                            
                                    onClick={() => {
                                        setIsChecked(true)
                                    }}>
                                    <div className='radioContent'>
                                        <div 
                                            style={{fontSize: 16, color: '#000', lineHeight: '24px', display: 'flex', alignItems: 'baseline'}}
                                        >
                                            <Radio checked={isChecked}></Radio>
                                            <span style={{ margin: '0 8px' }}>Annually</span>
                                            {/* <span className='breaks'>Save {chosenPlan === 'business' ? '15%' : '17%'}</span> */}
                                        </div>
                                        <div className="payment-page-title-confirm-save-price">
                                            <span className="payment-page-title-confirm-save-inner"> ${chosenPlan === 'business' ? 360 : 80}</span>
                                            <span className="payment-page-title-confirm-when-inner"> /year</span>
                                        </div>

                                    </div>
                                    {/* <div style={{fontSize: 12, color: '#707070', paddingLeft: 34, marginTop: 12, letterSpacing: '0.5px'}}>You will pay ${chosenPlan === 'business' ? 360 : 80} per year, saving you {chosenPlan === 'business' ? '15%' : '17%'} cost.</div> */}
                                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <span
                                            className="payment-page-title-confirm-save-tag"
                                        >
                                            Save ${chosenPlan === 'business' ? "60" : "16"}/year
                                        </span>
                                    </div>
                                </div>
                                <div 
                                    style={{
                                        border: !isChecked
                                            ? "2px solid #325CEB"
                                            : "1px solid #D9D9D9",
                                        borderRadius: "10px",
                                        padding: "12px",
                                        cursor: (currentPlan === 'originator' && ['annually', 'yearly'].includes(recurringInterval)) ? "not-allowed" : "pointer",
                                        background: (currentPlan === 'originator' && ['annually', 'yearly'].includes(recurringInterval)) ? "#f5f5f5" : "#fff",
                                        opacity: (currentPlan === 'originator' && ['annually', 'yearly'].includes(recurringInterval)) ? 0.6 : 1,
                                    }}
                                    onClick={() => {
                                        // 如果是 individual 年付用户，禁用月付选择
                                        if (currentPlan === 'originator' && ['annually', 'yearly'].includes(recurringInterval)) {
                                            return;
                                        }
                                        setIsChecked(false)
                                    }} 
                                >

                                    <div className='radioContent'>

                                        <div style={{fontSize: 16, color: '#000', lineHeight: '24px', display: 'flex', alignItems: 'baseline'}}>  
                                            <Radio 
                                                checked={!isChecked}
                                                disabled={currentPlan === 'originator' && ['annually', 'yearly'].includes(recurringInterval)}
                                            ></Radio>
                                            <span style={{ margin: '0 8px' }}>Monthly</span>  
                                        </div>
                                        <div className="payment-page-title-confirm-save-price">
                                            <span className="payment-page-title-confirm-save-inner">
                                                ${chosenPlan === "business" ? 35 : 8}
                                            </span>
                                            <span className="payment-page-title-confirm-when-inner">
                                                /month
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Monthly option disabled notice */}
                                {currentPlan === 'originator' && ['annually', 'yearly'].includes(recurringInterval) && (
                                    <div style={{
                                        fontSize: "12px",
                                        color: "#999",
                                        textAlign: "center",
                                        marginTop: "8px",
                                        fontStyle: "italic"
                                    }}>
                                        Individual annually subscribers can only upgrade to annually plans
                                    </div>
                                )}
                            </div>
                        {/* } */}
                    </div>
                {/* </Col>
                <Col lg={9} span={24}> */}
                    <div 
                        className="payment-form-content-promo-code"
                    >
                        <div 
                            style={{ 
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                cursor: "pointer",
                            }}
                            onClick={() => setPromoCodeExpanded(!promoCodeExpanded)}
                        >
                            <div style={{fontSize: 16, fontWeight: 500}}>Promo code</div>
                            <div style={{
                                transform: promoCodeExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s ease'
                            }}>
                                {promoCodeExpanded 
                                    ? <div style={{ fontSize: 20, color: '#6E6E70' }}><MinusCircleOutlined className='promoCodeIcon' /></div> 
                                    : <div style={{ fontSize: 20, color: '#6E6E70' }}><PlusCircleOutlined className='promoCodeIcon' /></div>}
                            </div>
                        </div>
                        

                        <div className='mt-2' style={{
                            width: '100%',
                            maxHeight: promoCodeExpanded ? '200px' : '0',
                            opacity: promoCodeExpanded ? 1 : 0,
                            overflow: 'hidden',
                            transition: 'all 0.3s ease-in-out',
                            marginTop: promoCodeExpanded ? '16px' : '0',
                        }}>
                            {promoCodeApplied ? (
                                <div style={{ 
                                    width: '100%',
                                    borderRadius: '8px', 
                                    backgroundColor: '#FFFFFF',
                                    padding: '12px', 
                                    display: 'flex', 
                                    alignItems: 'center',
                                    transition: 'all 0.3s ease-in-out',
                                    justifyContent: 'space-between' 
                                }}>
                                    <div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div style={{ 
                                                width: '16px', 
                                                height: '16px', 
                                                borderRadius: '50%', 
                                                backgroundColor: '#13358D', 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                justifyContent: 'center',
                                                marginRight: '8px',
                                                color: '#fff',
                                                border: '1px solid #13358D'
                                            }}>✓</div>
                                            <div style={{fontSize: 14, color: '#586570'}}>Code applied</div>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div style={{ marginLeft: 24, fontSize: 16 }}>{promoCode.toUpperCase()}</div>
                                        </div>
                                    </div>
                                    <div 
                                        style={{ cursor: 'pointer', color: '#C41212', fontSize: '14px' }} 
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleRemovePromoCode();
                                        }}
                                    >
                                        Remove
                                    </div>
                                </div>
                            ) : (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Input 
                                        placeholder="Enter promo code" 
                                        value={promoCode}
                                        onChange={(e) => {
                                            setPromoCode(e.target.value);
                                            setPromoCodeError(false);
                                        }}
                                        style={{ 
                                            flex: 1, 
                                            height: '44px',
                                            backgroundColor: '#FFFFFF',
                                            borderColor: promoCodeError ? '#ff4d4f' : '#d9d9d9',
                                            borderRadius: '8px'
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (promoCodeError) {
                                                setPromoCode('');
                                                setPromoCodeError(false);
                                            }
                                        }}
                                    />
                                    <Button 
                                        type='secondary'
                                        style={{ 
                                            marginLeft: '8px', 
                                            height: '44px',
                                            width: '80px',
                                            backgroundColor: '#F7F8FF !important',
                                            borderColor: '#325CEB'  ,
                                            borderRadius: '8px !important',
                                            color: '#325CEB',
                                            fontWeight: 500,
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleApplyPromoCode();
                                        }}
                                    >
                                        Apply
                                    </Button>
                                </div>
                            )}
                            {promoCodeError && (
                                <div style={{ color: '#ff4d4f', fontSize: '12px', marginTop: '4px' }}>
                                    Invalid promo code!
                                </div>
                            )}
                        </div>

                    </div>

                    {payID ? (
                        <Elements
                            stripe={stripePromise}
                            options={options}
                        >
                            <NewInformation
                                chosenPlan={chosenPlan}
                                userNum={userNum} 
                                stripeCustomerID={stripeCustomerID} 
                                promoCode={promoCodeApplied ? promoCode : undefined}
                                appliedPromoCode={appliedPromoCode}
                                ref={info} 
                                payID={payID} 
                                loanOfficers={CurrentLoanOfficers} 
                                billingFrequency={isChecked ? 'Annually' : 'Monthly'} 
                                paymentMethodsExpanded={paymentMethodsExpanded}
                                setPaymentMethodsExpanded={setPaymentMethodsExpanded}
                                getInfo={(e) => {
                                    console.log('getInfo---------00', e)
                                    if (e.to) {
                                        back()
                                        return
                                    }

                                    if (e.back) {
                                        setModalOpen(true)

                                    } else {
                                        setPayLoading(e.loading)
                                    }
                                }} 
                            />
                        </Elements>
                    ) : (
                        <div style={{ 
                            padding: '20px', 
                            textAlign: 'center', 
                            color: '#666',
                            backgroundColor: '#f9f9f9',
                            borderRadius: '8px'
                        }}>
                            Loading payment form...
                        </div>
                    )} 

                    <div className='plansAndPricing-rightCard' style={{ padding: '16px 20px', marginTop: '20px' }}>
                        <div className='plansAndPricing-rightCard-title'> Order Summary </div>
                        <div className='lansAndPricing-rightCard-plan' style={{margin: '14px 0 19px'}}>
                            <div>{chosenPlan === 'business' ? 'Zeitro Business Plan' : 'Zeitro Individual Plan'}</div>
                            <div> ${getUSD()} USD</div>
                        </div>
                        <div className={ 'lansAndPricing-rightCard-plan-details '}>
                            <div>
                                {/* <div style={{marginBottom: 7}}>{getNumberOfSeats()} user{CurrentLoanOfficers.length > 1 ? 's' : ''}</div> */}
                                <div>{isChecked ? 'Annual subscription' : "Monthly subscription"}</div>
                            </div>
                            {/* <div style={{fontSize: 10, color: '#707070'}}>{getDom()}</div> */}
                        </div>
                        {showExtra()}

                        {
                            promoCodeApplied && <div className='lansAndPricing-rightCard-plan mb-5'>
                                <div>Promo code</div>
                                <div>- ${(parseFloat(getUSD()) - parseFloat(getTotal())).toFixed(2)} USD</div>
                            </div>
                        }

                        <div style={{ color: '#707070', fontSize: 13, lineHeight: '18px', paddingBottom: 22, borderBottom: '1px solid #CCC' }} className={promoCodeApplied ? 'mt-3' : 'mt-5'}>
                            By clicking Continue, you are authorizing future charges if you invite additional Paid Tier users.
                        </div>

                        <div className='lansAndPricing-rightCard-plan' style={{margin: '22px 0 38px'}}>
                            <div>Today's total</div>
                            <div> ${getTotal()} USD</div>
                        </div>
                        {
                            // isPay ? 
                            <Button loading={payLoading} type="primary" className='lansAndPricing-rightCard-btn' onClick={() => {
                                info.current.click()
                                // setPayLoading(true)

                                // setTimeout(() => {
                                //     setPayLoading(false)
                                // }, 1000)
                            }}>Pay</Button> 
                            // :
                            // <Button loading={continueLoading} type="primary" className='lansAndPricing-rightCard-btn' onClick={() => { clickContinue() }}>Continue</Button>
                        }
                        <div style={{ color: "#70707", marginTop: '16px', fontSize: 10, lineHeight: '14px' }}>
                            Local taxes may apply based on your billing information. Final charges may vary and will be detailed in your email invoice. By clicking Continue, you authorize us to: 1) securely store your payment method; 2) update the billing amount based on the number of Paid Tier users and the usage of the Automated Soft Credit Pull feature; 3) automatically charge you at the end of every billing cycle.
                        </div>
                    </div>
                </Col>
                <Col lg={9} span={24}>
                    <div className="question-box">
                        <div className="question-box-title">Frequently asked questions</div>
                        <div className="question-box-content">
                        <div className="question-box-content-item">
                            <div className="question-box-content-item-title">
                            Can I change plans later on?
                            </div>
                            <div className="question-box-content-item-answer">
                            Yes. You can change plans, or cancel anytime by navigating to
                            Plans and Pricing.
                            </div>
                        </div>
                        <div className="question-box-content-item">
                            <div className="question-box-content-item-title">
                            Can I cancel my subscription?
                            </div>
                            <div className="question-box-content-item-answer">
                            You can cancel your subscription anytime by navigating to
                            Billing Management.
                            </div>
                        </div>
                        </div>
                    </div>
                </Col>

            </Row>
            <Modal 
                width={566}
                className='upgrade-modal' open={ModalOpen} footer={null} onCancel={() => {
                back()
                setModalOpen(false)
            }}>
                <div style={{
                    display: 'grid',
                    placeItems: 'center',
                    textAlign: 'center'
                }}>

                    <div style={{width: '100%', marginTop: '63px'}}>
                        <div style={{marginTop: '65px'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="81" height="52" viewBox="0 0 81 52" fill="none">
                                <path d="M22.3223 11.4803L16.157 25.4055L18.7082 35.9292L34.1215 32.9528L33.0586 22.2166L22.3223 11.4803Z" fill="#A4B7F8"/>
                                <path d="M58.7826 11.4803L64.948 25.4055L62.3968 35.9292L46.9834 32.9528L48.0464 22.2166L58.7826 11.4803Z" fill="#A4B7F8"/>
                                <path d="M4.46387 13.1812L16.7921 45.2836H64.4191L76.7473 13.1812L55.0412 28.5946L40.6056 3.61426L26.17 28.5946L4.46387 13.1812Z" fill="#EAEFFD"/>
                                <circle cx="40.4989" cy="5.20866" r="5.20866" fill="#EAEFFD"/>
                                <circle cx="4.35827" cy="13.5" r="4.35827" fill="#EAEFFD"/>
                                <circle cx="76.642" cy="13.5" r="4.35827" fill="#EAEFFD"/>
                                <rect x="16.7957" y="46.3464" width="47.622" height="5.31496" fill="#C3CDEA"/>
                                <path d="M36.335 30.1884L40.6058 24.6614L45.0022 30.314L40.7314 35.8409L36.335 30.1884Z" fill="#325CEB"/>
                            </svg>
                        </div>
                        <div style={{ fontSize: '24px', fontWeight: "bold",margin:"16px 0px" }}>You're all set! </div>
                        <div style={{ fontSize: '16px', fontWeight: "400",    width: '100%' }}>{chosenPlan === 'business' ? 'You’ve upgraded to the Business Plan.' : 'You’ve upgraded to the Individual Plan.'}</div>
                        {chosenPlan === 'originator' && <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #ececec', padding: '15px 28px', marginTop: '96px'}}>
                            <div 
                                onClick={() => {
                                    back()
                                    setModalOpen(false)
                                }} 
                                style={{ 
                                    color: '#325CEB',
                                    textAlign: 'center',
                                    fontSize: 16,
                                    fontWeight: 600,
                                    lineHeight: '20px',
                                    padding: '11px 16px',
                                    cursor: 'pointer'
                                }}
                            >
                                Close
                            </div>
                        </div>}
                        {chosenPlan === 'business' && <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #ececec', padding: '15px 28px', marginTop: '96px'}}>
                            <div 
                                onClick={async () => {
                                    // 在切换到 user management 菜单之前，先更新 Redux 中的 subscription 信息
                                    try {
                                        let token = sessionStorage.getItem("ZeitroA")
                                        const response = await fetch('/los/getcurrentsubscription', {
                                            method: 'get',
                                            headers: {
                                                Authorization: "Bearer " + token,
                                                Cache: "no-cache"
                                            }
                                        })
                                        
                                        if (response.ok) {
                                            const latestSubscription = await response.json()
                                            console.log('Updating Redux before switching to user management:', latestSubscription)
                                            
                                            // 更新 Redux store 中的 subscription 信息
                                            dispatch({
                                                type: "SUBSCRIPTION_INFO",
                                                data: latestSubscription
                                            })
                                        }
                                    } catch (error) {
                                        console.error("Error updating subscription in Redux:", error)
                                    }
                                    
                                    // 切换到 user management 菜单
                                    if (props.invite) {
                                        props.invite(null) // 传递 null 来触发菜单切换
                                    }
                                    setModalOpen(false)
                                }} style={{backgroundColor: '#325CEB', color: '#fff', width: '122px', padding: '11px 16px', fontSize: 16, fontWeight: 600, fontFamily: 'Inter', borderRadius: '6px', cursor: 'pointer'}}
                            >
                                Invite users
                            </div>
                        </div>}
                        
                    </div>
                </div>


            </Modal>
            <UserModal isModalOpen={isModalOpen} loanOfficers={CurrentLoanOfficers} closeModal={(e) => {
                if (!e) {

                    setIsModalOpen(false)
                    return
                }
                setCurrentLoanOfficers(e)
                // setUserNum(e.length)
                setIsModalOpen(false)


            }}></UserModal>
        </div>
    )

    function showExtra() {
        if (chosenPlan === 'business' && CurrentLoanOfficers.length > businessPlanUserLimit) {
            return <div className={ 'lansAndPricing-rightCard-plan-details '}>
                <div>
                    <div>Extra seats</div>
                    <div style={{fontSize: 12, color: '#6E6E70', marginTop: 5}}>{CurrentLoanOfficers.length - businessPlanUserLimit} seats at ${isChecked ? 80 : 8}/seat</div>
                </div>
                <div>${(CurrentLoanOfficers.length - businessPlanUserLimit) * (isChecked ? 80 : 8)} USD</div>
        </div>
        } 
        return ""
    }

    function getDom() {
        // 计算显示的用户数量和计费用户数量
        let displayUserCount = CurrentLoanOfficers.length;
        let billingUserCount;
        
        if (chosenPlan !== 'originator') {
            billingUserCount = displayUserCount;
        } else {
            // individual 方案：显示所有用户，但只按一个人计费
            billingUserCount = 1;
        }

        return (
            <>
                <div style={{ color: '#707070' }}>
                    {isChecked ? <div className='Dom'> {chosenPlan === 'business' ? '$30' : '$6.67'} x {billingUserCount} user{billingUserCount > 1 ? 's' : ''} x 12 months</div> : <div className='Dom'>

                        {chosenPlan === 'business' ? '$35' : '$8'}*{billingUserCount} user{billingUserCount > 1 ? 's' : ''}
                    </div>}
                    {/* {chosenPlan !== 'business' && <div style={{ fontSize: '12px', color: '#707070', marginTop: '4px' }}>
                        * Covers all {displayUserCount} users in your organization
                    </div>} */}

                </div>

            </>

        )

    }
    function getDate() {
        const today = new Date(); // 获取当前日期时间

        if (isChecked) {
            // 创建一个新的日期对象，年份增加1，其他日期和时间部分保持与today相同
            const nextYearToday = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());
            return nextYearToday.toDateString()

        } else {
            const nextMonthToday = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
            return nextMonthToday.toDateString()
        }


    }
    function getUSD() {
        // 计算收费的用户数量
        let userCount;
        if (chosenPlan !== 'originator') {
            // business 方案：按所有用户收费
            userCount = CurrentLoanOfficers.length;
        } else {
            // individual 方案：只按一个人收费，但所有用户都生效
            userCount = 1;
        }

        if (isChecked) {
            if (chosenPlan === 'business') {
                if (CurrentLoanOfficers.length <= businessPlanUserLimit) {
                    return "360"
                } else {
                    return ((CurrentLoanOfficers.length - businessPlanUserLimit) * 80 + 360).toFixed(0)
                }
            } else {
                return (userCount * 6.67 * 12).toFixed(0)
            }
        } else {
            if (chosenPlan === 'business') {
                if (CurrentLoanOfficers.length <= businessPlanUserLimit) {
                    return "35"
                } else {
                    return ((CurrentLoanOfficers.length - businessPlanUserLimit) * 8 + 35).toFixed(0)
                }
            } else {
                return (userCount * 8).toFixed(0)
            }
        }

    }

    function getTotal() {
        if (!promoCodeApplied) {
            return getUSD();
        }

        const basePrice = parseFloat(getUSD());
        const code = appliedPromoCode.toUpperCase();
        
        if (isChecked) {
            // annually plan discounts
            if (code === 'MAXCLASS90YEAR') {
                return (basePrice * (9/12)).toFixed(2); // 3/12 discount
            } else if (code === 'MAXCLASS60YEAR') {
                return (basePrice * (10/12)).toFixed(2); // 2/12 discount
            } else if (code === 'ZEITRO30YEAR' || code === 'WELCOME30YEAR' || code === 'SPECIAL30YEAR') {
                return (basePrice * (11/12)).toFixed(2); // 1/12 discount
            } else if (code === 'ORIGINATOR60YEAR' || code === 'WELCOME60YEAR' || code === 'SPECIAL60YEAR') {
                return (basePrice * (10/12)).toFixed(2); // 2/12 discount
            } else if (code === 'PREMIUM90YEAR' || code === 'WELCOME90YEAR' || code === 'SPECIAL90YEAR' || code === 'FRIENDS90YEAR') {
                return (basePrice * (9/12)).toFixed(2); // 3/12 discount
            } else if (code === 'FRIENDS180YEAR') {
                return (basePrice * (6/12)).toFixed(2); // 6/12 discount
            }
        } else {
            // Monthly plan discounts
            if (code === 'MAXCLASS90') {
                return "0.00"; // Full discount for monthly
            } else if (code === 'MAXCLASS60') {
                return "0.00"; // Full discount for monthly
            } else if (code === 'ZEITRO30' || code === 'WELCOME30' || code === 'SPECIAL30') {
                return "0.00"; // Full discount for monthly
            } else if (code === 'ORIGINATOR60' || code === 'WELCOME60' || code === 'SPECIAL60') {
                return "0.00"; // Full discount for monthly
            } else if (code === 'PREMIUM90' || code === 'WELCOME90' || code === 'SPECIAL90' || code === 'FRIENDS90') {
                return "0.00"; // Full discount for monthly
            } else if (code === 'FRIENDS180') {
                return "0.00"; // Full discount for monthly
            }
        }
        
        return getUSD();
    }

}